import { getAccountId, getSeekId } from '@seek/adv-account-selection';
import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { log, setUser } from 'src/app/utils/logging';
import { actionUpdateAdvertiserId } from 'src/app/v1/state/modules/session/advertiserId';
import { actionUpdateSeekAdvertiserId as actionUpdateSessionSeekAdvertiserId } from 'src/app/v1/state/modules/session/seekAdvertiserId';
import { actionUpdateSeekAdvertiserId as actionUpdateTealiumSeekAdvertiserId } from 'src/app/v1/state/modules/tealium/seekAdvertiserId';
import { useLocalisedRoutes } from 'src/app/v1/views/hooks/useLocalisedRoutes';
import type { AppState } from 'src/types/appState';

export const useAdvertiserId = () => {
  const { advertiserId, isDataCleanupComplete, seekAdvertiserId } = useSelector(
    (state: AppState) => ({
      advertiserId: state.session.advertiserId,
      seekAdvertiserId: state.session.seekAdvertiserId,
      isDataCleanupComplete: state.app.isDataCleanupComplete,
    }),
    shallowEqual,
  );
  const dispatch = useDispatch();
  const accountId = getAccountId();
  const seekId = getSeekId();
  const { redirectToDashboard } = useLocalisedRoutes();
  useEffect(() => {
    if (!accountId && !advertiserId && !seekAdvertiserId && !seekId) {
      log.error('useAdvertiserId | advertiser id missing', {
        accountId,
        advertiserId,
        isDataCleanupComplete,
        seekAdvertiserId,
        seekId,
      });
      return redirectToDashboard();
    }

    if (isDataCleanupComplete) {
      if (accountId && !advertiserId) {
        dispatch(actionUpdateAdvertiserId(accountId));
      }

      if (seekId && !seekAdvertiserId) {
        dispatch(actionUpdateSessionSeekAdvertiserId(String(seekId)));
        dispatch(actionUpdateTealiumSeekAdvertiserId(String(seekId)));
        setUser(String(seekId));
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    accountId,
    advertiserId,
    isDataCleanupComplete,
    seekAdvertiserId,
    seekId,
  ]);
};
